import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const sendContactForm = createAsyncThunk("contact/sendContactForm", async (formValues, { rejectWithValue }) => {
  try {
    const formData = new FormData();

    for (const key in formValues) {
      if (formValues[key] !== undefined && formValues[key] !== null) {
        formData.append(key, formValues[key]);
      }
    }

    const response = await axios.post("https://milkys.bytesway.io/api/contact-us", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    return response.data;
  } catch (error) {
    console.error("API Error Response: ", error.response?.data);
    return rejectWithValue(error.response?.data || "Unknown error");
  }
});

const ContactSlice = createSlice({
  name: "contact",
  initialState: {
    loading: false,
    error: null,
    success: false,
  },
  reducers: {
    resetContactFormState: (state) => {
      state.loading = false;
      state.error = null;
      state.success = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(sendContactForm.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(sendContactForm.fulfilled, (state) => {
        state.loading = false;
        state.success = true;
      })
      .addCase(sendContactForm.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Submission failed";
      });
  },
});

export const { resetContactFormState } = ContactSlice.actions;
export default ContactSlice.reducer;
